<template>
  <div>
    <canvas
      style="z-index:-1;"
      v-bind:width="width"
      v-bind:height="height"
      id="imageCanvas"
      class="check_tool__image_canvas"
    ></canvas>
    <canvas
      style="z-index:0;"
      v-bind:width="width"
      v-bind:height="height"
      id="drawCanvas"
      class="check_tool__image_canvas__draw"
    ></canvas>
  </div>
</template>

<script>
import client from '@/api/client';

export default {
  props: {
    probsWidth: null,
    probsHeight: null,
    probsItem: null,
    probImageSource: null,
    probsBoxes: {
      type: Array,
      required: true,
    },
    probsToggleBoxShow: null,
    probsLandmark: {
      type: Array,
      required: false,
    },
    probsToggleLandmark: null,
  },
  data() {
    return {
      width: 900,
      height: 500,
      scale: 1.0,
      imageCanvas: null, // 圖片層
      imageCtx: null, // 圖片層
      drawCanvas: null, // 畫畫層
      drawCtx: null, // 畫畫層
      hideBox: false,
      boxes: [],

      // color def
      BOX_COLOR_DEF: {
        person: '#24ceb9',
        face: 'darkorchid',
        head: 'red',
        hand: 'cornflowerblue',
        leg: 'khaki',
        bed: 'green',
        ear: '#EE7700',
        roi: '#FF44AA',
      },
      LANDMARK_COLOR_DEF: {
        eye: 'red',
        nose: 'green',
        mouth: 'blue',
      },
    };
  },
  watch: {
    probsWidth() {
      console.log(`prob width: ${this.probsWidth}`);
      this.width = this.probsWidth;
    },
    probsHeight() {
      this.height = this.probsHeight;
    },
    probsItem() {
      this.loadImage(this.probsItem);
    },
    probsBoxes() {
      this.drawBoxes(this.probsBoxes);
    },
    probsToggleBoxShow() {
      this.toggleBoxShow();
    },
    probsLandmark() {
      this.drawLandmark(this.scale, this.probsLandmark);
    },
  },
  methods: {
    loadImage(item) {
      const vm = this;
      this.hideBox = false;

      // image
      vm.imageCanvas = document.getElementById('imageCanvas');
      vm.imageCtx = vm.imageCanvas.getContext('2d');

      // drawing box, landmarks
      vm.drawCanvas = document.getElementById('drawCanvas');
      vm.drawCtx = vm.imageCanvas.getContext('2d');

      vm.imageObj = new Image();

      let url = '';
      if (vm.probImageSource === 'prod') {
        url = `/data/prod/${item.user_id}/${item.device_id}/${item.date}/${item.store_type}/${item.name}`;
      } else if (vm.probImageSource === 'pipeline') {
        url = `/data/${item.batch_type}/${item.batch_date}/${item.name}`;
      } else if (vm.probImageSource === 'ai_data') {
        url = `/ai_data/${item.location}/${item.batch_type}/${item.user_id}/${item.date}/${item.name}`;
      }
      console.log('loading image...');
    
      vm.imageObj.onload = () => {
        vm.imageCtx.clearRect(0, 0, vm.width, vm.height);
        vm.drawCtx.clearRect(0, 0, vm.width, vm.height);
        vm.scale = vm.getScale(vm.imageObj.width, vm.imageObj.height);
        vm.roi_scale = vm.getScale(1920, 1080);
        vm.imageCtx.drawImage(
          vm.imageObj,
          0,
          0,
          vm.imageObj.width * vm.scale,
          vm.imageObj.height * vm.scale,
        );
        console.log('load image success!!');
        vm.$emit('image-loaded', item);
      };

      vm.imageObj.onerror = () => {
        vm.$emit('image-not_found', item);
        console.log('load image fail!!');
      }

      client.getBlob(url).then((res) => {
        try {
          vm.imageObj.src = URL.createObjectURL(res);
        } catch (e) {
          vm.$emit('image-not_found', item);
          console.log('load image fail!!');
        }
      });

    },
    drawBoxes(boxes) {
      this.boxes = boxes;
      for (let i = 0; i < this.boxes.length; i++) {
        let box_class = '';
        if ('description' in this.boxes[i]) {
          box_class = this.boxes[i].description;
        } else {
          box_class = this.boxes[i].class;
        }
        if (box_class === 'roi') {
          this.drawBox(this.roi_scale, this.boxes[i]);
        } else {
          this.drawBox(this.scale, this.boxes[i]);
        }
      }
    },
    drawBox(scale, box) {
      const { bbox } = box;
      const x = Math.round(bbox[0] * scale);
      const y = Math.round(bbox[1] * scale);
      const w = Math.round(bbox[2] * scale) - x;
      const h = Math.round(bbox[3] * scale) - y;

      let box_class = '';
      if ('description' in box) {
        box_class = box.description;
      } else {
        box_class = box.class;
      }
      const boxStyle = this.getBoxStyle(box_class);
      this.drawCtx.lineWidth = boxStyle.lineWidth;
      this.drawCtx.strokeStyle = boxStyle.colorStyle;

      this.drawCtx.strokeRect(x, y, w, h);
      this.drawTitle(box_class, boxStyle.colorStyle, x, y);
    },
    drawLandmark(scale, landmark) {
      let landmark_type = '';
      for (let i = 0; i < landmark.length; i += 2) {
        // i = 0 ~ 3 eye
        // i = 4,5 nose
        // i = 6 ~ 9 mouth

        if (i < 4) {
          landmark_type = 'eye';
        } else if (i >= 4 && i < 6) {
          landmark_type = 'nose';
        } else {
          landmark_type = 'mouth';
        }
        this.drawPoint(landmark[i], landmark[i + 1], landmark_type);
      }
    },
    drawPoint(x, y, draw_type) {
      const vm = this;
      if (x != -1 && y != -1) {
        vm.drawCtx.fillStyle = vm.LANDMARK_COLOR_DEF[draw_type];
        vm.drawCtx.fillRect(x * this.scale - 3, y * this.scale - 3, 6, 6);
      }
    },
    getScale(width, height) {
      // 獲得 900*500（aspect fit rate）圖片壓縮比例
      let scale = this.height / height;
      if (width * scale > this.width) {
        scale = this.width / width;
      }
      return scale;
    },
    toggleBoxShow() {
      this.hideBox = !this.hideBox;
      if (this.hideBox) {
        this.imageCtx.clearRect(0, 0, 900, 500);
        this.imageCtx.drawImage(
          this.imageObj,
          0,
          0,
          this.imageObj.width * this.scale,
          this.imageObj.height * this.scale,
        );
      } else {
        this.drawBoxes(this.probsBoxes);
      }
    },
    getBoxStyle(calss_def) {
      const boxDef = { colorStyle: '', lineWidth: 1 };
      boxDef.colorStyle = this.BOX_COLOR_DEF[calss_def];
      if (calss_def == 'roi') {
        boxDef.lineWidth = 5;
      }
      return boxDef;
    },
    drawTitle(class_def, fillStyle, x, y) {
      // 將label所代表的部位顯示出來
      const vm = this;
      vm.drawCtx.fillStyle = fillStyle;
      vm.drawCtx.fillRect(x, y, `${(class_def.length + 1) * 10}`, -25);
      vm.drawCtx.fillStyle = 'black';
      vm.drawCtx.fillText(class_def, `${x + 5}`, `${y - 5}`);
    },
  },
};
</script>
